export const INSIGHT_TYPE_MAPPING = [
  {
    key: "isBuyside",
    text: "Buy-side",
    muteText: "Buy-side",
    mutedContentsKey: "is-buyside",
  },
  {
    key: "isExchangeSponsored",
    text: "Exchange-sponsored",
    muteText: "Exchange-sponsored",
    mutedContentsKey: "is-exchange-sponsored",
  },
  {
    key: "isBroker",
    text: "Broker report",
    muteText: "Broker",
    mutedContentsKey: "is-broker",
  },
  {
    key: "isIssuerPaid",
    text: "Issuer-paid",
    muteText: "Issuer-paid",
    mutedContentsKey: "is-issuerpaid",
  },
  {
    key: "isPodcast",
    text: "Podcast",
    muteText: "Podcast",
    mutedContentsKey: "is-podcast",
  },
  {
    key: "isSyndicated",
    text: "Syndicated",
    muteText: "Syndicated",
    mutedContentsKey: "is-syndicated",
  },
];

export const INSIGHT_TYPES = [
  {
    name: "Broker",
    key: "isBroker",
    filterKey: "is-broker",
    description: "Research published by sell side firms",
  },
  {
    name: "Issuer-paid",
    key: "isIssuerpaid",
    filterKey: "is-issuerpaid",
    description: "Research sponsored by issuers/companies",
  },
  {
    name: "Exchange-sponsored",
    key: "isExchangeSponsored",
    filterKey: "is-exchange-sponsored",
    description: "Research sponsored by public/private market exchanges",
  },
  {
    name: "Syndicated",
    key: "isSyndicated",
    filterKey: "is-syndicated",
    description: "Research curated from across the web",
  },
  {
    name: "Podcasts",
    key: "isPodcast",
    filterKey: "is-podcast",
    description: "Audio curated from across the web",
  },
  {
    name: "Buy-side",
    key: "isBuyside",
    filterKey: "is-buyside",
    description: "Research/letters published by the buy side",
  },
  {
    name: "Insight",
    key: "isInsight",
    filterKey: "",
    description: "Independent research published by verified providers",
  },
];

export const MUTE_INSIGHT_TYPES = [
  {
    name: "Broker",
    key: "is-broker",
    description: "Research published by sell side firms",
  },
  {
    name: "Issuer-paid",
    key: "is-issuerpaid",
    description: "Research sponsored by issuers/companies",
  },
  {
    name: "Exchange-sponsored",
    key: "is-exchange-sponsored",
    description: "Research sponsored by public/private market exchanges",
  },
  {
    name: "Syndicated",
    key: "is-syndicated",
    description: "Research curated from across the web",
  },
  {
    name: "Podcasts",
    key: "is-podcast",
    description: "Audio curated from across the web",
  },
  {
    name: "Buy-side",
    key: "is-buyside",
    description: "Research/letters published by the buy side",
  },
];
